import DataTable from 'components/ui/DataTable/data-table';
import CustomDataTable from 'pages/private/FeedbackEvaluation/tables/CustomDataTable';
import Modal from 'components/ui/Modal/modal';
import PrimaryButton from 'components/ui/PrimaryButton';
import SecondaryButton from 'components/ui/SecondaryButton';
import React, { FC, useState } from 'react';
import { Cell } from 'react-table';
import { toast } from 'react-toastify';
import {
  ITraineeDetail,
  ITraineeStatus,
  useApproveTraineeMutation,
  useListPendingTraineeQuery,
  useListRejectedTraineeQuery,
  useRejectTraineeMutation
} from 'redux/reducers/user';
import { boolean } from 'yup';
import { useListRoutineModuleQuestionQuery } from 'redux/reducers/routineFeedback';
import { useParams } from 'react-router-dom';
interface IRoutineManagementTable {
  tableHeaders?: () => React.ReactNode;
  // status: boolean;
}

const RoutineFeedbackTable: FC<IRoutineManagementTable> = ({ tableHeaders }) => {
  const { id } = useParams();
  const { data: routinefeedbackModuleData, isLoading } = useListRoutineModuleQuestionQuery(id);

  const mappedData = routinefeedbackModuleData?.data?.filter((item: any, index: number) => {
    if (item.feedback_question_details.length !== 0) {
      return item.feedback_question_details;
    }
  });

  const newMappedData = mappedData?.map(function (item: any) {
    return item.feedback_question_details;
  });

  const columns = [
    {
      Header: 'S.N',
      accessor: 'sn',
      Cell: (cell: Cell) => {
        return cell.row.index + 1;
      }
    },
    {
      Header: 'Feedback in English',
      accessor: 'question'
    },
    {
      Header: 'Feedback in Nepali',
      accessor: 'question_np'
    }

    // {
    //   Header: 'Status',
    //   accessor: (row: ITraineeDetail) => ITraineeStatus[Number(row.user_details.status)]
    // },
    //   {
    //     Header: '  Action',
    //     Cell: (data: Cell<ITraineeDetail>) => {
    //       return +data.row.original?.user_details.status === ITraineeStatus.Pending ? (
    //         <>
    //           <PrimaryButton
    //             title="Approve"
    //             type="button"
    //             onClick={() => setUserDetail(data.row.original)}
    //           />
    //           <PrimaryButton
    //             className="ms-2"
    //             isDanger
    //             title="Reject"
    //             type="button"
    //             onClick={() => {
    //               setIsReject(true);
    //               setUserDetail(data.row.original);
    //             }}
    //           />
    //         </>
    //       ) : +data.row.original?.user_details.status === ITraineeStatus.Rejected ? (
    //         <PrimaryButton
    //           title="Approve"
    //           type="button"
    //           onClick={() => setUserDetail(data.row.original)}
    //         />
    //       ) : (
    //         ''
    //       );
    //     }
    //   }
  ];
  return (
    <>
      <div>
        <CustomDataTable
          columns={columns}
          isLoading={isLoading}
          // data={Array.isArray(newMappedData?.[0]) ? newMappedData[0] : []}
          data={
            (!!routinefeedbackModuleData?.data?.length &&
              routinefeedbackModuleData?.data?.[0]?.feedback_question_details) ||
            []
          }
          tableHeaders={tableHeaders}
        />
      </div>
    </>
  );
};

export default RoutineFeedbackTable;
